import React, { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'

interface AgeVerificationModalProps {
  isOpen: boolean
}

export default function AgeVerificationModal({ isOpen }: AgeVerificationModalProps) {
  const [ageConfirmed, setAgeConfirmed] = useState(false)
  const [termsAccepted, setTermsAccepted] = useState(false)
  const { verifyAge } = useAuth()

  if (!isOpen) return null

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    if (ageConfirmed && termsAccepted) {
      verifyAge()
    }
  }

  const canSubmit = ageConfirmed && termsAccepted

  return (
    <div className="age-verification-overlay">
      <div className="age-verification-modal">
        <div className="age-verification-header">
          <h2>Age Verification Required</h2>
          <div className="kratom-leaf-icon">🌿</div>
        </div>
        
        <div className="age-verification-content">
          <p className="age-verification-notice">
            This website contains information about kratom products and provides links to vendors 
            that sell kratom and related accessories. You must be at least 21 years of age to access this content.
          </p>
          
          <div className="age-verification-warnings">
            <h3>Important Legal Information:</h3>
            <ul>
              <li>Kratom products have not been evaluated or approved by the U.S. Food and Drug Administration (FDA) for safety, effectiveness, or as a treatment for any medical condition. The information provided on this website is for educational purposes only and should not be construed as medical advice. Kratom is not intended to diagnose, treat, cure, or prevent any disease.</li>
              <li>Kratom laws vary by state and locality - check your local laws</li>
            </ul>
          </div>
          
          <form onSubmit={handleSubmit} className="age-verification-form">
            <div className="checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={ageConfirmed}
                  onChange={(e) => setAgeConfirmed(e.target.checked)}
                  required
                />
                <span className="checkmark"></span>
                I am 21 years of age or older
              </label>
            </div>
            
            <div className="checkbox-group">
              <label className="checkbox-label">
                <input
                  type="checkbox"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)}
                  required
                />
                <span className="checkmark"></span>
                I understand that kratom laws vary by location and I am responsible for knowing the laws in my area
              </label>
            </div>
            
            <div className="age-verification-actions">
              <button 
                type="submit" 
                className={`verify-age-btn ${canSubmit ? 'enabled' : 'disabled'}`}
                disabled={!canSubmit}
              >
                Enter Site
              </button>
              <button 
                type="button" 
                className="exit-btn"
                onClick={() => window.history.back()}
              >
                I am under 21 / Exit
              </button>
            </div>
          </form>
          
          <div className="age-verification-footer">
            <p>
              By entering this site, you agree that you are of legal age and that you have read 
              and understand these terms. This verification will be remembered for future visits.
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}